import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';
import { useTradingOfferOperations } from '../context/TradingOfferOperationsContext';

const TradingOfferOperationsTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = useTradingOfferOperations();

  const hasOptions = !data.isReadOnly;

  const columns = [
    data.isPartnerView && { key: 'operation', content: t('Operation') },

    data.isPartnerView && { key: 'offerRef', content: t('OfferRef') },

    { key: 'ref', content: t('Ref') },

    { key: 'date', content: t('Date') },

    data.isPartnerView && { key: 'counterparty', content: t('Counterparty') },

    !data.isPartnerView && { key: 'buyer', content: t('Buyer') },

    !data.isPartnerView && { key: 'seller', content: t('Seller') },

    { key: 'shares', content: t('Shares'), textPosition: 'right' },

    { key: 'amount', content: t('Amount'), textPosition: 'right' },

    { key: 'status', content: t('Status') },

    hasOptions ? { key: 'actions', content: '', textPosition: 'left' } : null,
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default TradingOfferOperationsTableHeader;
